import * as React from "react";

export const RegisterScreen: React.FC = () => {
    return <p>Register</p>;
};
